// 書籍、評論、特輯連載頁面
import axios from 'axios'
import {API_URL} from './config.js'

export default {
  getUserBookGroupList: function (sortType = 1, page = 1) {
    let params = {
      sortType: sortType,
      page: page
    }
    axios.get(`${API_URL}/UserBook/BookGroupList${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log('getUserBookGroupList')
      console.log(response)
      this.authors = response.data
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getUserBooks: function (bookGroupID = '24f5a163-43a3-4f29-477e-08d5cad01720', sortType = 1, page = 1) {
    let params = {
      bookGroupID: bookGroupID,
      sortType: sortType,
      page: page
    }
    axios.get(`${API_URL}/UserBook/BooksList${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log('getUserBooks')
      console.log(response)
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getUserReadingRecords: function (sortType = 1, page = 1) {
    let params = {
      sortType: sortType,
      page: page
    }
    axios.get(`${API_URL}/Reader/ReadingRecords${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log(response)
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  }
}



// WEBPACK FOOTER //
// ./src/bookcase.js